"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _Select = _interopRequireDefault(require("../Select"));
var _Stepper = _interopRequireDefault(require("./Stepper"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _SelectionStepper = _interopRequireDefault(require("./SelectionStepper.proptypes"));
var _constant = require("./constant");
var _constant2 = require("../constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var StepperWrapper = _styledComponents.default.div.withConfig({
  displayName: "SelectionStepper__StepperWrapper",
  componentId: "sc-1v7jgc3-0"
})([""]);
var StepperContainer = _styledComponents.default.div.withConfig({
  displayName: "SelectionStepper__StepperContainer",
  componentId: "sc-1v7jgc3-1"
})([""]);
var SelectItemContainer = _styledComponents.default.div.withConfig({
  displayName: "SelectionStepper__SelectItemContainer",
  componentId: "sc-1v7jgc3-2"
})([""]);
var SelectionStepperWrapper = _styledComponents.default.div.withConfig({
  displayName: "SelectionStepper__SelectionStepperWrapper",
  componentId: "sc-1v7jgc3-3"
})(["display:flex;align-items:center;justify-content:space-between;margin-bottom:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.small;
});
var LabelContainer = _styledComponents.default.div.withConfig({
  displayName: "SelectionStepper__LabelContainer",
  componentId: "sc-1v7jgc3-4"
})(["display:flex;flex-direction:column;width:191px;"]);
var ChildAgeSelectionWrapper = _styledComponents.default.div.withConfig({
  displayName: "SelectionStepper__ChildAgeSelectionWrapper",
  componentId: "sc-1v7jgc3-5"
})(["display:grid;grid-template-columns:repeat(2,1fr);column-gap:8px;row-gap:1em;margin-bottom:", ";"], function (_ref2) {
  var isShowChildAgeInput = _ref2.isShowChildAgeInput;
  return isShowChildAgeInput ? '16px' : '0px';
});
var SelectionStepper = function SelectionStepper(props) {
  var onStepperClicked = props.onStepperClicked,
    data = props.data,
    device = props.device,
    setChildAge = props.setChildAge,
    labelColor = props.labelColor,
    subLabelColor = props.subLabelColor,
    stepperConfig = props.stepperConfig,
    theme = props.theme,
    accessible = props.accessible,
    isShowChildAgeInput = props.isShowChildAgeInput,
    enablePaxAgeUpdate = props.enablePaxAgeUpdate,
    paxType = props.paxType;
  var _ref3 = data || {},
    label = _ref3.label,
    subLabel = _ref3.subLabel,
    subLabelIcon = _ref3.subLabelIcon,
    min = _ref3.min,
    max = _ref3.max,
    number = _ref3.number,
    type = _ref3.type,
    childAge = _ref3.childAge,
    ageList = _ref3.ageList,
    placeholder = _ref3.placeholder;
  var belowMin = min != null && number <= min;
  var aboveMax = max != null && number >= max;
  var _useState = (0, _react.useState)(childAge !== null && childAge !== void 0 ? childAge : null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    childrenAge = _useState2[0],
    setChildrenAge = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    currentSelect = _useState4[0],
    setCurrentSelect = _useState4[1];
  var getValidNumber = function getValidNumber() {
    if (belowMin) return min;
    if (aboveMax) return max;
    return number;
  };
  var _useState5 = (0, _react.useState)(getValidNumber()),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    total = _useState6[0],
    setTotal = _useState6[1];
  var onIncrementPax = function onIncrementPax() {
    onStepperClicked(total + 1);
    setTotal(total + 1);
    if (isShowChildAgeInput && type === _constant.PAX_TYPE.child && ageList && ageList.length > 0) {
      setChildrenAge([].concat((0, _toConsumableArray2.default)(childrenAge), [ageList[0]]));
      setChildAge([].concat((0, _toConsumableArray2.default)(childrenAge), [ageList[0]]));
    }
  };
  var onDecrementPax = function onDecrementPax() {
    onStepperClicked(total - 1);
    setTotal(total - 1);
    if (isShowChildAgeInput && type === _constant.PAX_TYPE.child) {
      childrenAge.pop();
      setChildrenAge((0, _toConsumableArray2.default)(childrenAge));
      setChildAge((0, _toConsumableArray2.default)(childrenAge));
    }
  };
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var tabIndex = !accessible ? '-1' : '0';
  var changeChildAge = function changeChildAge(item, index) {
    var newChildAge = (0, _toConsumableArray2.default)(childrenAge);
    newChildAge[index] = item;
    setChildrenAge(newChildAge);
    setChildAge(newChildAge);
    setCurrentSelect(null);
  };
  var renderAgeSelectList = function renderAgeSelectList(count) {
    var ageSelectList = [];
    var _loop = function _loop(i) {
      if (childrenAge && childrenAge[i]) {
        var _placeholder$childAge;
        ageSelectList.push( /*#__PURE__*/_react.default.createElement(SelectItemContainer, null, /*#__PURE__*/_react.default.createElement(_Select.default, {
          key: "child_age_item_key_".concat(i),
          items: ageList,
          value: childrenAge[i].value,
          label: placeholder === null || placeholder === void 0 || (_placeholder$childAge = placeholder.childAgeDropdownLabel) === null || _placeholder$childAge === void 0 ? void 0 : _placeholder$childAge.replace('{0}', i + 1),
          isShowChildAgeInput: isShowChildAgeInput,
          inputIndex: i,
          isMobile: device === _constant2.DEVICE_TYPE.MOBILE,
          currentSelect: currentSelect,
          onChange: function onChange(value, item) {
            return changeChildAge(item, i);
          },
          setCurrentSelect: setCurrentSelect,
          "data-test": "child-age-picker",
          "aria-label": "child-age-picker",
          enablePaxAgeUpdate: enablePaxAgeUpdate
        })));
      }
    };
    for (var i = 0; i < count; i++) {
      _loop(i);
    }
    return ageSelectList;
  };
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(StepperWrapper, null, /*#__PURE__*/_react.default.createElement(SelectionStepperWrapper, {
      tabIndex: tabIndex,
      id: "selection-stepper",
      theme: themeContext
    }, /*#__PURE__*/_react.default.createElement(LabelContainer, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      display: _constant.DEFAULT_STYLE.LABEL_DISPLAY,
      theme: theme,
      type: _constant.DEFAULT_STYLE.LABEL_TYPE,
      color: labelColor,
      customProperties: {
        id: 'selection-stepper-label'
      }
    }, label), subLabel && /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      display: _constant.DEFAULT_STYLE.SUB_LABEL_DISPLAY,
      theme: theme,
      type: _constant.DEFAULT_STYLE.SUB_LABEL_TYPE,
      color: subLabelColor,
      customProperties: {
        id: 'selection-stepper-subLabel'
      }
    }, subLabelIcon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: true,
      color: subLabelColor,
      fontsize: _constant.DEFAULT_STYLE.SUB_LABEL_ICON_SIZE,
      icon: subLabelIcon,
      customProperties: {
        style: {
          marginRight: '3px'
        }
      }
    }), subLabel)), /*#__PURE__*/_react.default.createElement(StepperContainer, null, /*#__PURE__*/_react.default.createElement(_Stepper.default, (0, _extends2.default)({
      accessible: false,
      min: min,
      max: max,
      number: total,
      onDecrement: onDecrementPax,
      onIncrement: onIncrementPax,
      theme: theme,
      paxType: paxType
    }, stepperConfig)))), isShowChildAgeInput && type === _constant.PAX_TYPE.child && /*#__PURE__*/_react.default.createElement(ChildAgeSelectionWrapper, {
      isShowChildAgeInput: isShowChildAgeInput && total > 0
    }, total > 0 && renderAgeSelectList(total)));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
SelectionStepper.propTypes = _SelectionStepper.default.PropTypes;
SelectionStepper.defaultProps = _SelectionStepper.default.DefaultProps;
var _default = SelectionStepper;
exports.default = _default;